import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import ServicesGrid from '../components/sections/ServicesGrid';
import AnalyticsCircles from '../components/sections/AnalyticsCircles'; // Import it!
import PreFooterCta from '../components/sections/PreFooterCta';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-royal-navy">
      <PageHeader title="Services" />
      
      <div className="pt-10">
        <ServicesGrid />
      </div>

      {/* The new glowing progress circles */}
      <AnalyticsCircles />

      <PreFooterCta />
    </div>
  );
};

export default ServicesPage;